import React,{ useRef } from "react";

import Contact from "../Components/Contact";

const Footer = () => {

 const myRef=useRef();
  const closeRef=useRef();



	const displayPrivacy=()=>{
    let element=myRef.current.style;
    element.display="block";
    element.position="fixed";
    element.top="5%";
    element.height="50vh";
    element.width="80vw";
    element.left="10vw";
   element.marginLeft="auto";
      element.marginRight="auto";
    element.backgroundColor="white";
    element.textAlign="center";
    element.zIndex=1;

	}

  const close=()=>{
    myRef.current.style.display="none";
  }
  return (


  	<>
  	
<div id="privacy" ref={myRef}>
<section>
<h2> Data Usage and Privacy Policy </h2>

</section>

<section>
<button onClick={close} ref={closeRef} id="close"> Close </button>
</section>

</div>
    <footer>
    

    <Contact/>

   
    <ul id="other-footer-links">
 	
 	<li onClick={displayPrivacy}> Data Privacy Policy </li>
 	<li> <a href="https://beast-o.com/community/" target="_blank" rel="noopener noreferrer"> Community Engagement </a> </li>
 	<li> <a href="https://beast-o.com/developers/" target="_blank" rel="noopener noreferrer"> Developer Tools and APIs </a></li>
  <li> <a href="https://beast-o.com/opensource/" target="_blank" rel="noopener noreferrer">Open Source Projects </a> </li>

    </ul>

    
  
    </footer>
    </>
  );
};
export default Footer;
